"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = void 0;

var tslib_1 = require("tslib");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_quantity_field_1 = require("@hopin-team/ui-quantity-field");

var date_fns_1 = require("date-fns");

var react_1 = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var context_1 = require("../context");

var StyledQuantityField = (0, styled_components_1.default)(ui_quantity_field_1.QuantityField)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));

var TimePicker = function TimePicker() {
  var _a, _b;

  var _c = (0, react_1.useContext)(context_1.DateFieldContext),
      date = _c.date,
      onDateChange = _c.onDateChange,
      hourLabel = _c.hourLabel,
      minuteLabel = _c.minuteLabel,
      minTime = _c.minTime,
      maxTime = _c.maxTime,
      stepTime = _c.stepTime;

  var minHourNumber = Number(minTime === null || minTime === void 0 ? void 0 : minTime.split(':')[0]);
  var maxHourNumber = Number(maxTime === null || maxTime === void 0 ? void 0 : maxTime.split(':')[0]);
  var minHour = minHourNumber > 12 ? minHourNumber - 12 : minHourNumber;
  var maxHour = maxHourNumber > 12 ? maxHourNumber - 12 : maxHourNumber;
  var hour = (_a = date && (0, date_fns_1.getHours)(date)) !== null && _a !== void 0 ? _a : 0;
  var minute = (_b = date && (0, date_fns_1.getMinutes)(date)) !== null && _b !== void 0 ? _b : 0;

  var getSteps = function getSteps(stepTime) {
    var hourStep = 0;
    var minuteStep = 0;

    if (stepTime) {
      if (stepTime > 3600) {
        hourStep = (0, date_fns_1.secondsToHours)(stepTime);

        if (stepTime / 60 > 60) {
          minuteStep = stepTime / 60 - 60;
        }
      } else {
        minuteStep = stepTime / 60;
      }
    }

    return [minuteStep, hourStep];
  };

  var _d = tslib_1.__read(getSteps(stepTime), 2),
      minuteStep = _d[0],
      hourStep = _d[1];

  var onChangeHours = function onChangeHours(e) {
    if (date && hour) {
      var hours = Number(e.target.value);

      if (hour > 12) {
        hours += 12;
      }

      onDateChange((0, date_fns_1.setHours)(date, hours));
    }
  };

  var onChangeMinutes = function onChangeMinutes(e) {
    return date && onDateChange((0, date_fns_1.setMinutes)(date, Number(e.target.value)));
  };

  var isAMSelected = hour < 12;

  var onAMClick = function onAMClick() {
    if (date && !isAMSelected) {
      onDateChange((0, date_fns_1.subHours)(date, 12));
    }
  };

  var onPMClick = function onPMClick() {
    if (date && isAMSelected) {
      onDateChange((0, date_fns_1.addHours)(date, 12));
    }
  };

  var onAddHours = function onAddHours() {
    if (date && !hourStep) {
      onDateChange((0, date_fns_1.addHours)(date, 1));
    } else if (date && hour && hourStep && minHourNumber <= hour && hour < maxHourNumber) {
      onDateChange((0, date_fns_1.addHours)(date, hourStep));
    }
  };

  var onAddMinutes = function onAddMinutes() {
    if (date && !minuteStep) {
      onDateChange((0, date_fns_1.addMinutes)(date, 1));
    } else if (date && minuteStep) {
      onDateChange((0, date_fns_1.addMinutes)(date, minuteStep));
    }
  };

  var onSubHours = function onSubHours() {
    if (date && !hourStep) {
      onDateChange((0, date_fns_1.subHours)(date, 1));
    } else if (date && hour && hourStep && minHourNumber < hour && hour <= maxHourNumber) {
      onDateChange((0, date_fns_1.subHours)(date, hourStep));
    }
  };

  var onSubMinutes = function onSubMinutes() {
    if (date && !minuteStep) {
      onDateChange((0, date_fns_1.subMinutes)(date, 1));
    } else if (date && minuteStep) {
      onDateChange((0, date_fns_1.subMinutes)(date, minuteStep));
    }
  };

  return react_1.default.createElement(ui_flex_1.Flex, {
    justifyContent: "space-between",
    pb: 3,
    pt: 1,
    px: 3
  }, react_1.default.createElement(StyledQuantityField, {
    sizeOption: "small"
  }, react_1.default.createElement(ui_quantity_field_1.QuantityInput, {
    value: date && (0, date_fns_1.format)(date, 'hh'),
    onChange: onChangeHours,
    min: minHour || 1,
    max: maxHour || 12,
    step: hourStep,
    "aria-valuemin": minHour || 1,
    "aria-valuemax": maxHour || 12,
    "aria-valuenow": hour,
    "aria-label": hourLabel
  }), react_1.default.createElement(ui_quantity_field_1.QuantitySpinButton, {
    onIncrement: onAddHours,
    onDecrement: onSubHours
  })), react_1.default.createElement(StyledQuantityField, {
    sizeOption: "small",
    px: 1,
    "arial-label": "minutes-spin"
  }, react_1.default.createElement(ui_quantity_field_1.QuantityInput, {
    value: date && (0, date_fns_1.format)(date, 'mm'),
    onChange: onChangeMinutes,
    step: minuteStep,
    min: 0,
    max: 59,
    "aria-valuemin": 0,
    "aria-valuemax": 59,
    "aria-valuenow": minute,
    "aria-label": minuteLabel
  }), react_1.default.createElement(ui_quantity_field_1.QuantitySpinButton, {
    onIncrement: onAddMinutes,
    onDecrement: onSubMinutes
  })), react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center"
  }, react_1.default.createElement(ui_button_1.Button, {
    size: "small",
    isOutlined: !isAMSelected,
    onClick: onAMClick,
    "data-testid": "am-button",
    "aria-selected": isAMSelected,
    mr: 1,
    type: "button"
  }, "AM"), react_1.default.createElement(ui_button_1.Button, {
    size: "small",
    isOutlined: isAMSelected,
    onClick: onPMClick,
    "data-testid": "pm-button",
    "aria-selected": !isAMSelected,
    type: "button"
  }, "PM")));
};

exports.TimePicker = TimePicker;
var templateObject_1;